<template>
	<div class="z-image-view">
		<div class="z-img-div"
			v-for="(item,index) in data"
			:style="{width:option.miniWidth || '120px',height:option.miniHeight || '120px',}">
			<img class="z-img"
				:src="item.url"
				@click="viewImage(item,index)" />
		</div>

		<div class="z-msk"
			:style="option.mskStyle || 'mskStyle'"
			v-show="showMsk">
			<div class="z-msk-div">
				<div class="close-div">
					<i class="el-icon-close"
						@click="closeView"></i>
				</div>

				<div class="view-img-div"
					@mousewheel.prevent="mouseScroll"
					@mousemove="dragMousemove"
					@mouseup.stop="isMousedown = false"
					v-if="data[imgViewIngIndex]">
					<img class="big-img"
						draggable="false"
						:style="{'transform':`scale(${imgScale}) rotate(${imgRotate}deg) scaleX(${imgScaleX}) scaleY(${imgScaleY}) translate(${translateX}px, ${translateY}px)`,transition:`all ${transition}s`}"
						:src="data[imgViewIngIndex].url"
						@mousedown="dragMousedown"
						@mouseup.stop="isMousedown = false" />
				</div>

				<div class="icon-div">
					<i class="el-icon-arrow-left"
						@click="upper"></i>
					<i class="el-icon-arrow-right"
						@click="next"></i>
					<i class="el-icon-zoom-in"
						@click="amplify"></i>
					<i class="el-icon-zoom-out"
						@click="reduce"></i>
					<i class="el-icon-refresh-left"
						@click="rotateLeft"></i>
					<i class="el-icon-refresh-right"
						@click="rotateRight"></i>
					<i class="el-icon-sort"
						@click="scaleX"
						style="transform:rotate(90deg)"></i>
					<i class="el-icon-sort"
						@click="scaleY"></i>
				</div>

				<div class="tip"
					v-show="firstTip">
					{{option.firstTip||'已是第一张'}}
				</div>
				<div class="tip"
					v-show="finalTip">
					{{option.finalTip||'已是最后一张'}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'z-image',
		props: {
			data: {
				type: Array,
				required: true
			},
			option: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				showMsk: false,
				imgViewIngIndex: 0,
				showAnimation: false,
				amplifyShow: false,
				transition: 0.5,
				imgScale: 0.4,
				imgScaleX: 1,
				imgScaleY: 1,
				imgRotate: 0,
				isMousedown: false, //鼠标是否按下
				translateX: 0,
				translateY: 0,
				moveStart: {
					x: 0,
					y: 0
				}, //拖拽元素初始位置
				firstTip: false,
				finalTip: false,
			}
		},
		watch: {
			data(newVal, oldVal) {
				this.$forceUpdate()
			}
		},
		created() {

		},
		methods: {
			viewImage(item, index) {
				this.showMsk = true;
				this.imgViewIngIndex = index;
				this.imgScale = 1;
				this.$emit('viewImage', item, index)
			},
			upper() {
				if (this.imgViewIngIndex - 1 != -1) {
					this.rest()
					this.imgScale = 1;
					this.imgViewIngIndex -= 1
				} else {
					this.firstTip = true
					setTimeout(() => {
						this.firstTip = false
					}, 3000)
				}
			},
			next() {
				if (this.imgViewIngIndex + 1 != this.data.length) {
					this.rest()
					this.imgScale = 1;
					this.imgViewIngIndex += 1
				} else {
					this.finalTip = true
					setTimeout(() => {
						this.finalTip = false
					}, 3000)
				}
			},
			amplify() {
				if (this.imgScale < 2) {
					this.imgScale += 0.2;
				}
			},
			reduce() {
				if (this.imgScale > 0.4) {
					this.imgScale -= 0.2;
				}
			},
			rotateLeft() {
				this.imgRotate -= 90;
				this.translateX = 0;
				this.translateY = 0;
			},
			rotateRight() {
				this.imgRotate += 90;
				this.translateX = 0;
				this.translateY = 0;
			},
			scaleX() {
				this.imgScaleX = this.imgScaleX == 1 ? -1 : 1;
			},
			scaleY() {
				this.imgScaleY = this.imgScaleY == 1 ? -1 : 1;
			},

			mouseScroll(e) {
				if (e.deltaY > 0) {
					if (this.imgScale > 0.4) {
						this.imgScale -= 0.2;
					}
				} else {
					if (this.imgScale < 2) {
						this.imgScale += 0.2;
					}
				}
			},
			dragMousedown(event) {
				this.moveStart.x = event.clientX
				this.moveStart.y = event.clientY
				this.isMousedown = true
			},
			dragMousemove(event) {
				if (this.isMousedown) {
					this.imgRotate = 0;
					this.imgScaleX = 1;
					this.imgScaleY = 1;
					this.transition = 0;
					this.translateX += (event.clientX - this.moveStart.x) / this.imgScale
					this.translateY += (event.clientY - this.moveStart.y) / this.imgScale
					this.moveStart.x = event.clientX
					this.moveStart.y = event.clientY
				}
			},
			rest() {
				this.translateX = 0;
				this.translateY = 0;
				this.transition = 0.5;
				this.imgScale = 1;
				this.imgScaleX = 1;
				this.imgScaleY = 1;
				this.imgRotate = 0;
				this.isMousedown = false
			},
			closeView() {
				this.showMsk = false;
			}

		}
	}
</script>
<style lang="scss"
	scoped>
	.z-image-view {
		width: 100%;
		height: 100%;
		position: relative;
		display: flex;
		flex-wrap: wrap;
		align-content: flex-start;

		.z-img-div {
			overflow: auto;
			position: relative;
			margin: 2px;
			display: flex;
			z-index: 1;

			.z-img {
				width: 100%;
				height: auto
			}

			.z-img-icon {
				position: absolute;
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				border: 1px red solid;
			}

			.el-icon-zoom-in {}

			:hover {
				color: #ffffff !important;
				font-size: 28px;
				z-index: 99999
			}
		}

		.z-msk {
			font-size: 22px;
			color: #ffffff;
			background-color: rgba(0, 0, 0, 0.5);
			height: 100%;
			width: 100%;
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			z-index: 9999;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			
			.z-msk-div {
				position: relative;
				height: 100%;
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;

				.close-div {
					width: 100%;
					text-align: right;
					position: absolute;
					top: 0;
					z-index: 9999;
				}

				.view-img-div {
					width: 100%;
					height: 100%;
					overflow: hidden;
					padding: 10px 10px;
					box-sizing: border-box;
					display: flex;
					align-items: center;
					justify-content: center;

					.big-img {
						min-width: 50px;
						width: auto;
						max-height: 100%;
						cursor: move;
					}
				}

				.icon-div {
					display: flex;
					justify-content: center;
					width: 100%;
					padding: 10px;
					box-sizing: border-box;
					position: absolute;
					bottom: 0;
				}
			}

			i {
				margin: 1px;
				font-size: 16px;
				cursor: pointer;
				background-color: rgba(0, 0, 0, 0.5);
				border-radius: 50%;
				padding: 6px;
				box-sizing: border-box;
			}

			.tip {
				position: absolute;
				background-color: black;
				opacity: 0.8;
				color: white;
				padding: 10px 20px;
				border-radius: 4px;
				z-index: 9999;
			}
		}
	}
</style>
